import React from 'react';
import { stencilApproxSize as tooltip } from 'pu-data/Tooltips';
import TextComponent from './TextComponent';

const StencilApproxSize = (props) => {
  const name = 'stencil_size';
  const {
    label, inputId, required, groupName, children, onChangeParameter, errorMessage,
  } = props
  const onChange = (e) => onChangeParameter(name, e.target.value);
  const { parameters } = props
  return (
    <TextComponent
      label={label}
      name={name}
      inputId={inputId}
      value={parameters[name] || ''}
      required={required}
      onChange={onChange}
      tooltip={tooltip}
      ignoreOnQuote
      groupName={groupName}
      errorMessage={errorMessage}>
      {children}
    </TextComponent>
  );
};

StencilApproxSize.defaultProps = {
  required: true,
  inputId: 'stencil-apprix-size',
  label: 'Approx. Stencil Size',
};

export default StencilApproxSize;
